import { getOperation } from "utils/api";
import {
  createOptionsCacheHook,
  resolveHasMoreOptions,
} from "./globalOptionsCache";

const PAGE_SIZE = 500;
const CACHE_NAMESPACE = "payfac-options";

const buildPayfacOption = (payfac) => {
  const id = payfac?.id || "";
  const payfacPrefix = payfac?.payfacPrefix || "";
  const name = payfac?.name || "";
  if (!payfacPrefix) return null;

  return {
    key: id || payfacPrefix,
    value: payfacPrefix,
    title: [id, payfacPrefix, name].filter(Boolean).join(" - "),
  };
};

const fetchPayfacOptionsFromApi = async (keyword) => {
  try {
    const apiResponse = await getOperation("/payfac", {
      sort: "id,ASC",
      page: 0,
      size: PAGE_SIZE,
      ...(keyword ? { keyword } : {}),
    });

    const responseBody = apiResponse?.data;
    if (!responseBody || responseBody.responseCode !== "0000") {
      return { options: [], hasMoreOptions: false };
    }

    const options = responseBody.data?.map(buildPayfacOption).filter(Boolean) || [];

    return {
      options,
      hasMoreOptions: resolveHasMoreOptions(
        responseBody.total,
        options.length,
        PAGE_SIZE,
      ),
    };
  } catch (error) {
    return { options: [], hasMoreOptions: false };
  }
};

export const usePayfacOptionsCache = createOptionsCacheHook({
  namespace: CACHE_NAMESPACE,
  buildCacheKey: (inputValue = "") => inputValue,
  fetcher: (inputValue = "") => fetchPayfacOptionsFromApi(inputValue),
  fetchProperty: "fetchPayfacOptions",
  invalidateProperty: "invalidatePayfacOptionsCache",
});
